import { css } from 'glamor';
import React from 'react';

import { Link } from 'react-router-dom'


const style = {
    tdLink: css({
        ':hover': { "textDecoration": 'none' },
    })
}
export type ITdLinkProps = {
    children?: React.ReactNode
    to?: string
}

const TdLink: React.FC<ITdLinkProps> = (props) => {
    const ContentTag = props.to ? Link : 'div';
    return (
        <td>
            <ContentTag to={props.to} onClick={(e) => {
                e.preventDefault()
            }} className={` ${style.tdLink}`} style={{ display: "contents", color: "inherit" }}>{props.children}</ContentTag>
        </td>
    );
}

export { TdLink };